<template>
  <el-card class="member-card-show">
    <div class="fitness-title">{{ $t('Contract.desc') }}</div>
    <el-form
      ref="form"
      :model="form"
      class="w-full"
      label-width="120px"
      v-loading="loading"
      label-suffix=":"
      v-if="form">
      <el-row type="flex" class="row-bg" justify="start" >
        <el-col :span="4">
          <el-form-item prop="id" :label="$t('Contract.id')" >{{ form.id }}</el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item prop="contractNum" :label="$t('Contract.number')" >{{ form.contractNum }}</el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item prop="status" :label="$t('Contract.status')" >{{ form.status }}</el-form-item>
        </el-col>
          <el-form-item prop="validityPeriod" :label="$t('Contract.validity_period')">{{ form.validityPeriod }}</el-form-item>
      </el-row>
      <el-row type="flex" class="row-bg" justify="start">
        <el-col :span="4">
          <el-form-item prop="clientId" :label="$t('Card.client_id')">{{ form.clientId }}</el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$t('Card.client_name')" prop="clientName">{{ form.clientName }}</el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$t('Sell.Show.client_phone')">{{ form.clientPhone }}</el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$t('Sell.Show.referrerID')">{{ form.recommendClientId }}</el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$t('Sell.Show.referrerName')">{{ form.recommendClientName }}</el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="start">
        <el-col :span="4">
          <el-form-item :label="$t('Sell.Show.Contract_Sales_StaffID')">{{ form.contractSalesStaffId }}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('Sell.Show.Contract_Sales_StaffName')" label-width="130px">{{ form.contractSalesStaffNickname }}</el-form-item>
        </el-col>
      </el-row>
      <div style="border-top:1px solid #ccc; margin: 30px 0"></div>
      <template>
        <el-table :data="tableData" border style="width: 100%;">
          <el-table-column prop="cardNum" align="center" :label="$t('Sell.Show.Customer_membership_card')"/>
          <el-table-column prop="cardStoreId" :label="$t('Sell.Show.Customer_membership_storeID')" align="center"/>
          <el-table-column prop="toBindCardNum" align="center" :label="$t('Sell.Show.Pending_binding_card')"/>
          <el-table-column prop="toBindCardStoreId" :label="$t('Sell.Show.Pending_binding_shop')" align="center"/>
          <el-table-column prop="storeId" align="center" :label="$t('Sell.Show.Open_Card_Store_ID')"/>
          <el-table-column prop="storeName" :label="$t('Sell.Show.Name_of_Open_Card_Store')" align="center"/>
        </el-table>
      </template>
      <div style="border-top:1px solid #ccc; margin: 30px 0"></div>
      <template>
        <el-table :data="tableData" border style="width: 100%;">
          <el-table-column prop="cardId" align="center" :label="$t('Card.id')"/>
          <el-table-column prop="cardName" align="center" :label="$t('Reception.First.card_name')"/>
          <el-table-column prop="cardCredit" align="center" :label="$t('Sell.Show.Membership_card_quota')"/>
          <el-table-column prop="cardBalance" :label="$t('Sell.Show.Credit_of_Membership_Card')" align="center"/>
          <el-table-column prop="supportStoreNames" align="center" :label="$t('Contract.support_store')"/>
        </el-table>
      </template>
      <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
      <template>
        <el-table :data="tableData" border style="width: 100%;">
          <el-table-column prop="status" align="center" :label="$t('Reception.Fourth.status')"/>
          <el-table-column prop="baseAmtStr" align="center" :label="$t('Charge.base_amt')"/>
          <el-table-column prop="discountAmtStr" :label="$t('Charge.discounted_price')" align="center"/>
          <el-table-column prop="payableAmtStr" align="center" :label="$t('Sell.Pay.amounts_payable')"/>
          <el-table-column prop="paidAmtStr" :label="$t('Charge.amount_paid')" align="center"/>
          <el-table-column prop="oweAmtStr" align="center" :label="$t('Charge.be_paid')"/>
        </el-table>
      </template>
      <div style="border-top:1px solid #ccc; margin: 30px 0"></div>
      <el-form-item prop="remark" :label="$t('Sell.Show.Contract_notes')">{{ form.remark }}</el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { Row, Col } from 'element-ui';

export default {
    components: {
        ElRow: Row,
        ElCol: Col,
    },
    data() {
        return {
            tableData: [],
            loading: false,
            form: null,
        };
    },
    watch: {},
    filters: {},
    created() {
        console.log('route', this.$route.params);
        if (this.$route.params.id) this.fetchData(this.$route.params.url);
    },
    mounted() {},
    methods: {
        fetchData(url) {
            this.loading = true;
            API.get(`${url}/${this.$route.params.id}`)
                .then(res => {
                    this.form = res;
                    this.tableData[0] = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style lang="scss">
.member-card-show {
    min-width: 1110px;
}
</style>
